import axiosInstance from '@api/axios';
import { urls } from '@api/urls';

export interface UseCaseGroup {
  id: number;
  name: string;
  order: number;
  created_at: string;
  updated_at: string;
}

export interface CreateUseCaseGroupData {
  name: string;
}

export interface UpdateUseCaseGroupData {
  name: string;
}

export const getUseCaseGroups = async (): Promise<UseCaseGroup[]> => {
  const response = await axiosInstance.get(urls.useCaseGroup.base);
  return response.data;
};

export const getUseCaseGroup = async (id: number): Promise<UseCaseGroup> => {
  const response = await axiosInstance.get(urls.useCaseGroup.byId(id));
  return response.data;
};

export const createUseCaseGroup = async (
  data: CreateUseCaseGroupData
): Promise<UseCaseGroup> => {
  const response = await axiosInstance.post(urls.useCaseGroup.base, data);
  return response.data;
};

export const updateUseCaseGroup = async (
  id: number,
  data: UpdateUseCaseGroupData
): Promise<UseCaseGroup> => {
  const response = await axiosInstance.patch(urls.useCaseGroup.byId(id), data);
  return response.data;
};

export const deleteUseCaseGroup = async (id: number): Promise<void> => {
  const response = await axiosInstance.delete(urls.useCaseGroup.byId(id));
  return response.data;
};

export const updateUseCaseGroupOrder = async (
  id: number,
  direction: 'up' | 'down'
): Promise<void> => {
  await axiosInstance.patch(urls.useCaseGroup.updateOrder(id), { direction });
};
